/**
 * 게임 글꼴. 모두 SIL OFL 1.1(상업적 이용 무료)이며 앱에 포함해 배포하므로 실행 중 외부 요청이 없다.
 * - 본문·HUD·게임 중 알림 배너: Pretendard. Pretendard에 없는 한자는 같은 본고딕 계열인 Noto Sans KR이 채운다.
 * - 고지서·제목: Noto Serif KR(본명조). 게임에 쓰는 한자를 모두 담고 있다.
 * Each face is split by unicode-range, so the browser fetches only the slices a screen uses.
 * styles.css carries the same stacks as --font-ui / --font-notice.
 */
import 'pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css';
import '@fontsource-variable/noto-sans-kr';
import '@fontsource-variable/noto-serif-kr';

export const FONT_SANS = `'Pretendard Variable', 'Noto Sans KR Variable', 'Malgun Gothic', 'Apple SD Gothic Neo', sans-serif`;
export const FONT_SERIF = `'Noto Serif KR Variable', 'Nanum Myeongjo', 'Batang', 'AppleMyungjo', serif`;

/**
 * Loads the slices `font` (a CSS font shorthand) needs for `text`. Canvas text does not wait for
 * web fonts, so canvas drawing calls this first. Never rejects: on failure the fallback face draws.
 */
export async function fontReady(font: string, text: string): Promise<void> {
  try {
    await document.fonts.load(font, text);
  } catch {
    // system fallback family
  }
}
